export default "__VITE_ASSET__Dp0xGa2X__"